var cookie = {
    setCookieV2: function (cookieOption) {
        if (!cookieOption.time) {
            cookieOption.time = 1.5 * 3600;
        }
        var exp = new Date();
        exp.setTime(exp.getTime() + cookieOption.time * 1000);
        cookieOption.value = encodeURIComponent(cookieOption.value);
        var hostname = cookieOption.domain ? cookieOption.domain : '.gaodun.com';
        document.cookie = cookieOption.key + '=' + cookieOption.value + '; domain=' + hostname + ';path=/;expires=' + exp.toGMTString();
    },
    setCookie: function (key, value, time) {
        if (!time) {
            time = 3 * 24 * 60 * 60;
        }
        var exp = new Date();
        exp.setTime(exp.getTime() + time * 1000);
        value = encodeURIComponent(value);
        var hostname = '.gaodun.com';
        document.cookie = key + '=' + value + '; domain=' + hostname + ';path=/;expires=' + exp.toGMTString();
    },
    getCookie: function (name) {
        var arr;
        var reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)');
        arr = document.cookie.match(reg);
        if (arr) {
            return decodeURIComponent(arr[2]);
        }
        else {
            return '';
        }
    },
    /**获取token对象，可以拿到过期时间和生效时间 */
    getCookieObj: function (name) {
        var token = cookie.getCookie(name);
        if (!token) {
            return null;
        }
        var res = token.split('.');
        var res2 = atob(res[1]);
        var tokenObj = JSON.parse(res2);
        return tokenObj;
    },
    delCookie: function (name) {
        this.setCookie(name, '', -1);
    },
};

export default cookie;
